import styled, { css } from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const MasterServicesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 185px);
  min-height: calc(100vh - 185px);
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.grey100};
`;

export const MasterServiceDeleteConfirmTitle = styled.div`
  padding: 24px 16px;
`;

export const extendDeleteConfirmModalBtn = css`
  background-color: ${({ theme }) => theme.colors.redMain};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`;

export const NoResultsWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`;

export const NoResultsText = styled(typography.TitleOneRegularTypography)``;

export const PaginationWrapper = styled.div`
  padding: 24px 0;
  background-color: ${({ theme }) => theme.colors.white};
  border-top: 1px solid ${({ theme }) => theme.colors.grey003};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`;

export const ErrorTextWrapper = styled.p`
  display: flex;
  justify-content: center;
  padding-bottom: 24px;
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
`;
